
export default [
  {
    _name: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
    roles: [ "ROLE_ADMIN"],
    badge: {
    
    }
  },
  
  {
    _name: 'CSidebarNavDropdown',
    name: 'Users',
    to: '/users',
    icon: 'cilPeople',
    roles: ["ROLE_ADMIN"],
    items: [

      {

        name: 'App Users',
        to: '/appusers',
        icon: 'cilUser',
        roles: ["ROLE_ADMIN"]
      },

      {

        name: 'CMS Users',
        to: '/Cmsusers',
        icon: 'cil-user-follow',
        roles: ["ROLE_ADMIN"]
      },

    ]
  },
  
  {
    _name: 'CSidebarNavItem',
    name: 'Categories',
    to: '/categories',
    icon: 'courses',
    roles: ["ROLE_ADMIN"]
  },

  {
    _name: 'CSidebarNavItem',
    name: 'Streams (Arts)',
    to: '/streams',
    icon: 'stream',
    roles: ["ROLE_ADMIN"]
  },
  {
    _name: 'CSidebarNavItem',
    name: 'Grades (Year)',
    to: '/grades',
    icon: 'grade',
    roles: ["ROLE_ADMIN"]
  },
  {
    _name: 'CSidebarNavItem',
    name: 'Subjects',
    to: '/courses',
    icon: 'subject',
    roles: ["ROLE_ADMIN"]
  },
 

  
  {
    _name: 'CSidebarNavItem',
    name: 'Classes',
    to: '/classes',
    icon: 'classes',  
    roles: ["ROLE_ADMIN"]
  },
  {
    _name: 'CSidebarNavItem',
    name: 'Sponsors',
    to: '/sponsors',
    icon: 'cilPuzzle',
    roles: ["ROLE_ADMIN"]
  },
]